'use client';

import dynamic from 'next/dynamic';
import Nav from '../components/nav';
import { TypePageLanding } from '@fm-nx/contentful-types';
const PageIntroLevel1Display = dynamic(() =>
    import('@fm-nx/ui').then((mod) => ({ default: mod.PageIntroLevel1Display }))
);
const BlockRenderer = dynamic(() => import('@fm-nx/ui').then((mod) => ({ default: mod.BlockRenderer })));

interface ExpertiseLandingProps {
    page: TypePageLanding<'WITHOUT_UNRESOLVABLE_LINKS'>;
    preview: boolean;
}

export default function ExpertiseLanding({ page, preview }: ExpertiseLandingProps) {
    const { sections = [], pageIntro, title } = page.fields;

    const image = pageIntro?.fields.image
        ? {
              sys: {
                  id: pageIntro.fields.image?.sys.id || '',
              },
              cloudinaryMedia: pageIntro.fields.image?.fields.cloudinaryMedia,
              description: pageIntro.fields.image?.fields.description || '',
              altText: pageIntro.fields.image?.fields.altText || '',
              title: pageIntro.fields.image?.fields.title || '',
              __typename: 'ImageWrapper' as 'ImageWrapper',
          }
        : null;

    return (
        <div>
            <Nav variant="dark" preview={preview} />
            {pageIntro && (
                <PageIntroLevel1Display
                    headerText={pageIntro.fields.headerText}
                    title={title}
                    headerParagraph={pageIntro.fields.headerParagraph}
                    gradient="blue-green-yellow"
                    button={{
                        ...pageIntro.fields.button,
                        sys: { id: pageIntro.fields.button?.sys.id || '' },
                        __typename: 'Button',
                    }}
                />
            )}
            <BlockRenderer block={sections} />
        </div>
    );
}
